import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WelcomeContainerComponent} from './container/welcome-container.component';
import {RouterModule, Routes} from '@angular/router';
import {DisplayWelcomePageComponent} from './components/display-welcome-page/display-welcome-page.component';
import {TranslateModule} from '@ngx-translate/core';
import {SharedModule} from '@shared/shared.module';
import {StartNewConsentPopupComponent} from './components/popups/start-new-consent-popup/start-new-consent-popup.component';
import {MatIconModule} from '@angular/material/icon';
import {A11yModule} from '@angular/cdk/a11y';


const routes: Routes = [
    {path: 'welcome', component: WelcomeContainerComponent}
];

@NgModule({
    declarations: [
        WelcomeContainerComponent,
        DisplayWelcomePageComponent,
        StartNewConsentPopupComponent
    ],
    exports: [
        DisplayWelcomePageComponent,
        StartNewConsentPopupComponent
    ],
    imports: [
        RouterModule.forChild(routes),
        CommonModule,
        TranslateModule,
        SharedModule,
        MatIconModule,
        A11yModule
    ]
})
export class WelcomeModule {
}
